import { Controller, Control, FieldValues, Path } from "react-hook-form";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";

import styles from "./ExclusiveCheckboxGroup.module.scss";

type Option<T> = {
  name: string;
  id: T;
};

interface Props<TForm extends FieldValues, TValue> {
  control: Control<TForm>;
  name: Path<TForm>;
  options: Option<TValue>[];
  disabled?: boolean;
}

export const ExclusiveCheckboxGroup = <TForm extends FieldValues, TValue>({
  control,
  name,
  options,
  disabled,
}: Props<TForm, TValue>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <FormGroup row>
          {options.map((option) => {
            const checked = field.value === option.id;

            return (
              <FormControlLabel
                key={String(option.id)}
                disabled={disabled}
                control={
                  <Checkbox
                    checked={checked}
                    disabled={disabled}
                    onChange={() => {
                      if (checked) {
                        field.onChange(null);
                      } else {
                        field.onChange(option.id);
                      }
                    }}
                    icon={<span className={styles.customBox} />}
                    checkedIcon={
                      <span className={`${styles.customBox} ${styles.checked}`}>
                        <CheckIcon />
                      </span>
                    }
                  />
                }
                label={option.name}
              />
            );
          })}
        </FormGroup>
      )}
    />
  );
};
